<template>
  <div
    class="alert myAlert fadeIn text-center"
    v-if="myShow && !timmedOut "
    >
    {{myMessage}}
  </div>

</template>

<script>

  export default {
    props:{
      message: String,
      show:Boolean,
      timeout :{
        default:5000
      },
    },
    data() {
      return {
        timmedOut: false,
        myShow: false,
        myMessage: '',
      }
    },
    methods: {
      msgTimeout(){
        this.myShow = this.show;
        this.myMessage = this.message;
        this.timmedOut = false;

        let timeout = false;
        if (this.timeout && this.timeout > 0 ) {
          timeout = this.timeout;
        } else if(!this.timeout) {
          timeout = 5000;
        }

        if (timeout) {
          setTimeout(() => {
            this.timmedOut = true;
            this.myShow = false;
            this.myMessage = '';
            this.$emit('done');
          }, timeout);
        }
      }
    },
    watch: {
      show: function(newVal, oldVal) { // watch it
        console.log(oldVal);
        console.log(newVal);
        this.msgTimeout();
      }
    },
    mounted() {
      this.msgTimeout();
    },
  }

</script>

<style scoped>
  .myAlert{
    text-align: center
  }
</style>
